import React, { memo, useEffect } from "react";
import { useParams } from "react-router-dom";
import { PageTemplate } from "../../components/templates";
import { Stack } from "investira.react.components";
import AtivosList from "./AtivosList";
import Carteira from "./Carteira";
import useKickBack from "../../hooks/useKickBack";
import withMessage from "../../hoc/withMessage";
import RecursoGarantidorProvider from "../../contexts/RecursoGarantidorContext";
import { useCarteirasContext } from "../../contexts/CarteirasContext";

const CarteiraEdit = memo((props) => {
  const params = useParams();
  const kick = useKickBack();

  const { state } = useCarteirasContext();

  // console.log("state", state);

  useEffect(() => {
    kick && props.onMessage("Entidade alterada");
  }, [kick]);

  return (
    <RecursoGarantidorProvider
      tipo="carteira"
      carteiraId={state.carteira_id}
      dataPosicao={state.data_posicao}
    >
      <PageTemplate title="Carteira" maxWidth={false}>
        <Stack spacing={2}>
          <Carteira id={params.id} mode="read" />
          <AtivosList carteiraId={params.id} />
        </Stack>
      </PageTemplate>
    </RecursoGarantidorProvider>
  );
});

CarteiraEdit.displayName = "CarteiraEdit";

export default withMessage(CarteiraEdit);
